import { connect } from "react-redux";
import * as actions from './actions'
import EmailAddressBook from "./EmailAddressBook";

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingAddressBook: state.emailAddressBook.isFetchingList,
    emailAddressBook: state.emailAddressBook.emailAddressBook,
    errors: state.emailAddressBook.errors,
    success: state.emailAddressBook.success,
    hasServerError: state.emailAddressBook.hasServerError,
    groups: state.emailAddressBook.groups,
    isFetchingGroups: state.emailAddressBook.isFetchingGroups,
    groupErrors: state.emailAddressBook.groupErrors,
    hasGroupServerError: state.emailAddressBook.hasGroupServerError,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  fetchEmailAddressBook: (token) => dispatch(actions.fetchEmailAddressBook(token)),
  clearErrors: () => dispatch(actions.clearErrors()),
  fetchGroups: (token) => dispatch(actions.fetchGroups(token)),
  clearGroupErrors: () => dispatch(actions.clearGroupErrors()),
  searchAddress: (keyword) => dispatch(actions.searchKeyword(keyword)),
  sortAddressBook: (type, sortType) => dispatch(actions.sortAddressBook(type, sortType))
})

const EmailAddressBookContainer = connect(mapStateToProps, mapDispatchToProps)(EmailAddressBook);

export default EmailAddressBookContainer;


// WEBPACK FOOTER //
// src/routes/EmailAddressBook/EmailAddressBookContainer.js